<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="logo">
          <img src="./assets/img/toplogo.png" alt/>
        </div>
        <el-menu
            :default-active="defaultActive"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            :router="router"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/case">软件列表</el-menu-item>
          <el-menu-item index="/goin">关于我们</el-menu-item>
        </el-menu>
      </el-header>
      <el-main>
        <router-view/>
      </el-main>
      <el-footer>
        <div class="footer">
          <div class="verify">
            <a href="https://beian.miit.gov.cn/" target="_blank"
            >黑ICP备2023011092号</a
            >
            <img src="./assets/img/icon.png" alt=""/>
            <a
                href="https://beian.mps.gov.cn/#/query/webSearch?code=23011002000635"
                rel="noreferrer"
                target="_blank"
            >黑公网安备23011002000635</a
            >
          </div>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false
    };
  },
  methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}

html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;
  //background-color: #fff;

  .logo {
    width: 280px;

    img {
      width: 100%;
      line-height: 60px;
    }
  }
}

.el-main {
  padding: 0 !important;
}

.footer {
  text-align: center;
  background-color: #ffffff;
}

.name {
  display: block;
  font-weight: 550;
  padding-top: 20px;
}

.verify {
  margin-top: 20px;
}

.verify img {
  vertical-align: middle;
  width: 20px;
  height: 20px;
  margin-left: 30px;
}

.verify a {
  color: #505050
}
</style>
